<template>
  <div>
    <vx-card>
      <div class="con-tab-ejemplo">
        <div class="vx-row">
          <!-- MULTIPLE COLUMNS-->
          <div class="vx-col w-full">
            <div class="vx-row">
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <vs-input class="w-full" label-placeholder="Tam ad" v-validate="'required'"  name="name" v-model="payment.name"  />
                <span class="text-danger text-sm" v-show="errors.has('name')">{{ 'Tam ad əlavə etmək zəruridir' }}</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <vs-input class="w-full" label-placeholder="Telefon" v-validate="'required'" name="phone" v-model="payment.phone" />
                <span class="text-danger text-sm" v-show="errors.has('phone')">{{ 'Telefon əlavə etmək zəruridir' }}</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <vs-input class="w-full" label-placeholder="Abunəçi kodu" name="code" v-validate="'required'"  v-model="payment.code" />
              </div>
            </div>
            <div class="vx-row" style="border: 1px solid rgb(204 204 204); margin: 4px 2px 4px 2px; border-radius: 5px; padding-top: 10px" v-for="(input, index) in pay"
                 :key="input"
                 v-bind:item="input"
                 v-bind:index="index">

              <div class="vx-col sm:w-2/5 w-full mb-2">
                Vergi
                <v-select :options="taxes" :clearable="false" v-model="input.tax_id" class="w-full"  :name="'taxes'+index" v-validate="'required'"  />
                <span class="text-danger text-sm" v-show="errors.has('taxes'+index)">{{ 'Vergi növü seçmək zəruridir' }}</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <vs-input class="w-full" label-placeholder="Ünvan" v-model="input.address" :name="'address'+index" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('address'+index)">{{ 'Ünvan əlavə etmək zəruridir' }}</span>
              </div>

              <div class="vx-col sm:w-1/4 w-full mb-2">
                <div class="vx-row">
                  <div class="vx-col sm:w-2/5 w-full mb-2">
                    <vs-input class="w-full" label-placeholder="Məbləğ" v-model="input.amount" :name="'amount'+index" v-validate="'required'"  />
                    <span class="text-danger text-sm" v-show="errors.has('amount'+index)">{{ 'Məbləğ əlavə etmək zəruridir' }}</span>
                  </div>
                  <div class="vx-col sm:w-2/5 w-full mb-2">
                    Ödəniş ili
                    <v-select :options="years" :clearable="false" v-model="input.year" class="w-full"  :name="'years'+index" v-validate="'required'"  />
                    <span class="text-danger text-sm" v-show="errors.has('years'+index)">{{ 'İl əlavə etmək zəruridir' }}</span>
                  </div>
                  <div class="vx-col sm:w-1/5 w-full mb-2">
                    <vs-button  v-if="index >0"  radius color="danger" type="gradient"  @click="deleteRow(index)" style="margin-top:17px; " icon-pack="feather" icon="icon-minus"></vs-button>
                    <vs-button  radius color="success" v-else type="gradient"  @click="addRow" style="margin-top:17px; " icon-pack="feather" icon="icon-plus"></vs-button>
                  </div>
                </div>
              </div>

            </div>


            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-button @click="payWithTerminal" class="mr-3 mb-2">Ödəniş et</vs-button>
                <vs-button color="warning" type="border" class="mb-2" @click="payment.name = '';">Təmizlə</vs-button>
              </div>
            </div>
          </div>
        </div>


      </div>
    </vx-card>
    <br>
    <vs-collapse accordion type="margin" class="p-0 bg-white">
      <vs-collapse-item v-for="(detailPaymentData,index) in paymentsData" class="faq-bg rounded-lg" :class="{'mt-0': !index}" :key="detailPaymentData.transaction_id">
        <div slot="header" @click="activePrint(index)"><h5>{{ detailPaymentData.taxes_name }}</h5>
        </div>
        <div class="flex flex-wrap items-center justify-between">
          <div class="flex items-center">
            <vs-button class="mb-base mr-3" icon-pack="feather" icon="icon icon-file" @click="printInvoice(index)">Print</vs-button>
          </div>
        </div>
        <div class="vx-row leading-loose p-base" :class="{'hide': showIndex !== parseInt(index)}">
          <div class="vx-col w-3/5 invoice-container">
            <!--          <h6> VISION TV MMC</h6>-->
            <div class="vx-col flex-2">
              <table>
                <tr>
                  <td class="font-semibold">VÖEN:</td>
                  <td>1701485351</td>
                </tr>
                <tr>
                  <td class="font-semibold">Terminal ID: </td>
                  <td>{{ detailPaymentData.taxes_name}} </td>
                </tr>
                <tr>
                  <td class="font-semibold">Payment ID: </td>
                  <td>{{detailPaymentData.transaction_id}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Ödəniş tarixi: </td>
                  <td>{{detailPaymentData.p_date}}</td>
                </tr>
              </table>
            </div>
            <p>
              Hörmətli Abunəçilər! Qəbzin surəti , qəbz itirildiyi, yaxud çap zamanı qəbzin istifadə ücün görüntüsü itdiyi halda yenidən verilir.Bu xidmət pulsuzdur və hec bir ödəniş qəbul edilmir.
            </p>
            ------------------------------------------------------------------
            <div class="vx-col flex-2">
              <table>
                <tr>
                  <td class="font-semibold">Şəhər: </td>
                  <td>{{detailPaymentData.city_name}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Rayon: </td>
                  <td>{{detailPaymentData.region_name}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Bələdiyyə: </td>
                  <td>{{detailPaymentData.m_name}}</td>
                </tr>
                <tr>
                  <td class="font-semibold"> Verginin tipi: </td>
                  <td>{{detailPaymentData.taxes_name}}</td>
                </tr>
                <tr>
                  <td class="font-semibold"> Ad Soyad: </td>
                  <td>{{detailPaymentData.name}}</td>
                </tr>
              <tr>
                <td class="font-semibold"> Abunəçi kodu: </td>
                <td>{{detailPaymentData.code}}</td>
              </tr>
                <tr>
                  <td class="font-semibold"> Telefon: </td>
                  <td>{{detailPaymentData.phone}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Ödənən verginin ünvanı:&nbsp; </td>
                  <td> {{detailPaymentData.p_address}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Ödənən verginin ili:  </td>
                  <td> {{detailPaymentData.years}} </td>
                </tr>
                <tr>
                  <td class="font-semibold"> Ödənilən məbləğ : </td>
                  <td>{{detailPaymentData.amount}} AZN</td>
                </tr>
              </table>
            </div>
            <p class="mb-4">Konstitusiyamızın 73 - cü maddəsinə əsasən qanunla müəyyən edilmiş vergi və ödənişləri tam həcmdə və vaxtında ödəmək hər kəsin borcudur.</p>
            <p>
              <span class="mr-8 font-semibold">Xahiş edirik ,ödənilən məbləğ hesabınıza köçürülənədək qəbzi özünüzdə saxlayın</span>
            </p>
          </div>
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import Input from '@/views/forms/form-elements/input/Input'
export default {
  components: {
    Input,
    vSelect
  },
  data: () => ({
    showIndex: null,
    colorx: 'success',
    payment : {
      name: '',
      phone:null,
      code:''
    },
    pay: [
      {
        amount: '',
        tax_id: null,
        address: null,
        year: { label: '2022', value: 2022, id:2022 }
      }
    ],
    years: [
      { label: '2015', value: 2015, id:2015 },
      { label: '2016', value: 2016, id:2016 },
      { label: '2017', value: 2017, id:2017 },
      { label: '2018', value: 2018, id:2018 },
      { label: '2019', value: 2019, id:2019 },
      { label: '2020', value: 2020, id:2020 },
      { label: '2021', value: 2021, id:2021 },
      { label: '2022', value: 2022, id:2022 }
    ]
  }),
  methods:{
    addRow () {
      this.pay.push({
        amount: '',
        tax_id: '',
        address: '',
        year: { label: '2022', value: 2022, id:2022 }
      })

    },
    deleteRow (index) {
      this.pay.splice(index, 1)
    },

    printInvoice (ind) {
      this.showIndex = ind
      window.print()
    },
    payWithTerminal () {
      // this.$i18n.locale = 'az';
      // this.$validator.locale = 'az';
      // const dictionary = {
      //   az: az,
      // };
      //
      // this.$validator.localize('az', az);
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          this.$store.dispatch('payments/payWithTerminal', {...this.payment, pay:this.pay }).then(response => {
            this.$vs.loading.close()
            this.payment = response.data
            this.$store.commit('payments/PAYED_INFOS_FOR_PRINT', response.data)
            this.$vs.notify({
              color: 'success',
              title: 'Uğurlu',
              text: 'Ödəniş uğurla həyata keçdi'
            })

            this.payment.name = null
            this.payment.phone = null
            this.pay = [
              {
                amount: null,
                tax_id: null,
                address: null,
                year: { label: '2022', value: 2022, id:2022 }
              }
            ]
          }

          ).catch(error => {
            this.$vs.loading.close()
            if (error.response.status === 422) {
              this.$vs.notify({
                color: 'danger',
                title: 'Error',
                text: 'Bütün sahələrin doldurulması zəruridir'
              })
            }

          })

        } else {
          this.$vs.loading.close()
          this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: 'Bütün sahələrin doldurulması zəruridir'
          })

        }
      })


    },
    activePrint (index) {
      this.showIndex = parseInt(index)
    }
  },
  created () {
    this.$store.dispatch('statistics/fetchTaxesData').catch(err => { console.error(err) })
  },
  computed:{
    taxes () {
      const taxesData =   this.$store.state.statistics.taxes
      const taxes = []
      taxesData.forEach((value) => {
        taxes.push({ label: value.name, value: value.name, id:value.id })
      })
      return taxes
    },
    paymentsData () {
      return this.$store.state.payments.printPayments
    }
  },
  mounted () {
    this.$emit('setAppClasses', 'invoice-page')
  }
}
</script>
<style lang="scss">
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }
    #content-area {
      margin: 0 !important;
    }
    .invoice-container,
    .invoice-container * {
      visibility: visible;
      margin: 0 !important;
    }
    .invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
      font-size: 10px;
    }

    .hide{
      display: none !important;
    }
  }
}

@page {
  size: auto;
}
</style>
